import { useMutation, useQueryClient } from '@tanstack/react-query';
import useUpdateProfile from './useUpdateProfile';
import getApiBaseUrl from '@/utils/getBaseUrl';

export default function useChangePhoto() {
  const { mutate: updateProfile } = useUpdateProfile();

  const token = window.localStorage.getItem('_token');

  return useMutation({
    mutationFn: async (payload: FormData) => {
      const response = await fetch(
        `${getApiBaseUrl()}/api/v1/common/files/upload-image`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: payload,
        },
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch profile: ${response.statusText}`);
      }

      return (await response.json()).data;
    },
    onSuccess: (data: { key: string; url: string }) => {
      updateProfile({
        photoUrl: data.url,
      });
    },
  });
}
